import React from "react";
import {FC} from "react";
import DtoTable from "../../components/dto-table/dto-table";
import useSafeState from "../../utils/safe-state";
import {Breadcrumb, Button, Col, InputNumber, Modal, Row, Space, Tooltip} from "antd";
import {Trans} from "@lingui/macro";
import {useAxios} from "../../utils/hooks";
import {EditTwoTone, FileImageTwoTone, PlusOutlined, PrinterOutlined, QrcodeOutlined} from "@ant-design/icons";
import {useKeycloak} from "@react-keycloak/web";
import DeliveryNoteModel from "../../models/dto/delivery-note-model";
import {RightOutlined} from "@ant-design/icons/lib";
import {openNotification} from "../../utils/openNotification";


const DeliveryScreen : FC = () => {

    const {initialized, keycloak} = useKeycloak();

    const [trigger, setTrigger] = useSafeState(false);

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL  + "");

    const [isModalVisible, setIsModalVisible] = useSafeState(false);
    const [deliveryNoteData] = useSafeState<Array<any>>([]);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
        
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleOnPrint = (record: any) => {
        if(axiosInstance.current != null){

            const FileDownload = require('js-file-download');

            deliveryNoteData.forEach(function(){
                deliveryNoteData.pop();
            });
            deliveryNoteData.push({
                key: (deliveryNoteData.length + 1).toString(),
                deliveryNoteNumber: record.deliveryNoteNumber,
                product: record.product,
                slot: record.slot,
                quantity: record.quantity,
                lotNumber: record.lotNumber,
                status: record.status,
                uploadedToKulcsSoft: record.uploadedToKulcsSoft
                
                
            });

            axiosInstance
                .current({
                    url: process.env.REACT_APP_API_BASE_URL + '/resource/delivery-notes/reprint-deliv-note-by-stock-list',
                    method: 'POST',
                    responseType: 'blob',
                    data: deliveryNoteData
                })
                .then(response => {
                    FileDownload(response.data, 'deliv_note.pdf');
                })
                .catch(function (error) {
                    openNotification('error', error);
                })
            

        }
    };

    const action = (record: any) => {

        return (
            <Space size="middle">
                <Tooltip placement="top" title={<Trans>Print Actual Delivery Note</Trans>}>
                    <PrinterOutlined
                        className={"ActionButtons"}
                        style={{color: "#40a9ff"}}
                        onClick={() => handleOnPrint(record)
                        }
                    />
                </Tooltip>
            </Space>
        );
    }


    const actions = {
        width: 40,
        render: (text: string, record: any) => action(record),
        title: '',
        fixed: 'right',
        align: 'center'
    };

    const qtyText = <Trans>Quantity</Trans>

    return  <>
        <Breadcrumb style={{ marginBottom: 10 }}>
            <Breadcrumb.Item><Trans id={'Homepage'}/></Breadcrumb.Item>
            <Breadcrumb.Item><Trans id={'Delivery'}></Trans></Breadcrumb.Item>
        </Breadcrumb>
        <DtoTable
            allowRefreshButton={true}
            model={DeliveryNoteModel}
            action={actions}
            trigger={trigger}
            pageSize={100}
            scroll={{ x: 1300, y: "60vh" }}
        />
    </>
}
export default DeliveryScreen;


